// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEdit_root__Uq9Py","pencil":"IconEdit_pencil__33Xui"};